import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { useAutoScrollToLastActive } from '../../internal/hooks';
import { AccordionItem } from '../../internal/components';
import { ALLOW_ONLY_ONE_OPENED, AUTO_SCROLL_TO_LAST_ACTIVE, SIZE, TEST_ID } from '../../internal/constants';
import { createElement as _createElement } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Компонент аккордеона. Принимает массив айтемов, отображая каждый из них как отдельный раскрывающийся блок.
 * Дополнительно может задавать им особое поведение.
 *
 * [Ссылка на макет](https://www.figma.com/design/4UM8zoowH9YGMM7fSK0rhD/%F0%9F%8C%90-Web-Components?node-id=42887-26758&t=HTw8sokOqTyz9FzP-4)
 */
export const Accordion = _ref => {
  let {
    items,
    onItemClick,
    testId = TEST_ID,
    size = SIZE,
    autoScrollToLastActive = AUTO_SCROLL_TO_LAST_ACTIVE,
    allowOnlyOneOpened = ALLOW_ONLY_ONE_OPENED
  } = _ref;
  const accordionItemsRef = React.useRef([]);
  const [openedItems, setOpenedItems] = React.useState(() => items.reduce((acc, curr, i) => {
    if (curr.defaultOpen) {
      acc.push(i);
    }
    return acc;
  }, []));
  const {
    scrollToLastActive
  } = useAutoScrollToLastActive({
    accordionItemsRef
  });
  const onAccordionItemClick = args => {
    const {
      target,
      open,
      index
    } = args;
    if (open) {
      setOpenedItems(items => items.filter(item => item !== index));
    } else if (allowOnlyOneOpened) {
      setOpenedItems(() => [index]);
    } else {
      setOpenedItems(items => [...items, index]);
    }
    if (onItemClick) {
      /**
       * На момент клика "open" еще хранит предыдущее состояние, поэтому чтобы
       * сказать "айтем только что открылся/закрылся" нужно инвертировать это значение
       */
      onItemClick({
        target,
        index,
        open: !open
      });
    }
    if (autoScrollToLastActive) {
      scrollToLastActive(index);
    }
  };
  return /*#__PURE__*/_jsx("div", {
    "data-testid": testId,
    children: items.map((item, index) => {
      const isOpen = openedItems.some(itemIndex => itemIndex === index);
      const handleClick = () => onAccordionItemClick({
        index,
        target: item,
        open: isOpen
      });
      return /*#__PURE__*/_createElement(AccordionItem, _objectSpread(_objectSpread({}, item), {}, {
        key: index,
        ref: ref => {
          accordionItemsRef.current[index] = ref;
        },
        index: index,
        size: size,
        open: isOpen,
        handleClick: handleClick
      }));
    })
  });
};